module.exports = __webpack_public_path__ + "img/nicaragua.b57044db.svg";